import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Inbox endpoints accept the artist platform token (/u/samtwo) OR the legacy
// admin token (admin panel). Prefer whichever is present.
export function inboxAuth() {
  const t = localStorage.getItem("samtwo_platform_token") || localStorage.getItem("samtwo_token");
  return { headers: { Authorization: `Bearer ${t}` } };
}

export const dmApi = {
  // SAMTWO / admin
  inbox: (search = "") => axios.get(`${API}/dms`, { ...inboxAuth(), params: { search } }),
  unreadCount: () => axios.get(`${API}/dms/unread-count`, inboxAuth()),
  conversation: (subscriberId) => axios.get(`${API}/dms/${subscriberId}`, inboxAuth()),
  reply: (subscriberId, body) => axios.post(`${API}/dms/${subscriberId}/reply`, { body }, inboxAuth()),
  markRead: (threadId) => axios.put(`${API}/dms/threads/${threadId}/read`, {}, inboxAuth()),
  archive: (threadId) => axios.delete(`${API}/dms/threads/${threadId}`, inboxAuth()),
  block: (subscriberId, blocked) => axios.put(`${API}/dms/${subscriberId}/block`, { blocked }, inboxAuth()),
  // Artist/admin-side on-demand translate of a received (subscriber) message into English.
  translate: (messageId, lang = "en") => axios.get(`${API}/dms/inbox/messages/${messageId}/translate`, { ...inboxAuth(), params: { lang } }),
};
